import { render, staticRenderFns } from "./OfferActivities.vue?vue&type=template&id=180c8654&"
import script from "./OfferActivities.vue?vue&type=script&lang=js&"
export * from "./OfferActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports